import { render, staticRenderFns } from "./MessageDisplay.vue?vue&type=template&id=73d9dd67&scoped=true&"
import script from "./MessageDisplay.vue?vue&type=script&lang=ts&"
export * from "./MessageDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MessageDisplay.vue?vue&type=style&index=0&id=73d9dd67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9dd67",
  null
  
)

export default component.exports